import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import CarDetail from "./pages/CarDetail";
import Admin from "./pages/Admin";
import { LangProvider } from "./lib/i18n";

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
  useEffect(() => { window.__lenis?.scrollTo(0, { immediate: true }); }, [pathname]);
  return null;
};

function App() {
  return (
    <LangProvider>
    <BrowserRouter>
      <SmoothScroll />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/auto/:id" element={<CarDetail />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Footer />
      <Toaster position="top-center" richColors />
    </BrowserRouter>
    </LangProvider>
  );
}

export default App;
